import React from 'react';
import PropTypes from 'prop-types';
import IconButton from 'material-ui/IconButton';
import Menu from 'material-ui/Menu';
import MoreVertIcon from 'material-ui-icons/MoreVert';

const anchorOrigin = {
	vertical: 'top',
	horizontal: 'right'
};
const transformOrigin = {
	vertical: 'top',
	horizontal: 'right'
};

const icon = (
	<MoreVertIcon/>
);

class AdminMenu extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			anchorEl: null
		};

		this.handleMenu = this.handleMenu.bind(this);
		this.handleClose = this.handleClose.bind(this);
	}

	render() {
		const {className, children} = this.props;
		const {anchorEl} = this.state;
		const open = !!anchorEl;

		return (
			<div className={className}>
				<IconButton aria-haspopup="true" onClick={this.handleMenu}>
					{icon}
				</IconButton>
				<Menu
					anchorEl={anchorEl}
					anchorOrigin={anchorOrigin}
					transformOrigin={transformOrigin}
					open={open}
					onClose={this.handleClose}
					onClick={this.handleClose}
				>
					{children}
				</Menu>
			</div>
		);
	}

	handleMenu(e) {
		this.setState({
			anchorEl: e.currentTarget
		});
	}

	handleClose() {
		this.setState({
			anchorEl: null
		});
	}
}

AdminMenu.propTypes = {
	className: PropTypes.string,
	children: PropTypes.node.isRequired
};

export default AdminMenu;



// WEBPACK FOOTER //
// ./src/client/components/admin/common/menu/index.jsx